import { Chip, TableCell, Typography } from '@mui/material';

import { ColumnInterface, GenericObject } from '@app/components/common/Table/DefaultTable/types';

import './styles.css';

interface PillsCellProps {
  row: GenericObject;
  column: ColumnInterface;
}

export const PillsCell = ({ row, column }: PillsCellProps) => {
  const getLabel = (item: GenericObject) => {
    return column?.format ? column?.format(item) : '';
  };

  return (
    <TableCell align="left">
      <div className="pills_container">
        {(row[column.key] as GenericObject[]).map(
          (item: GenericObject) =>
            getLabel(item) && (
              <Chip
                key={item.id as number}
                sx={{ marginRight: 1, marginBottom: 1 }}
                size="small"
                label={<Typography sx={{ fontSize: '0.7rem' }}>{getLabel(item)}</Typography>}
              />
            )
        )}
      </div>
    </TableCell>
  );
};
